window.addEventListener('load', () => {
    const faderList = document.querySelectorAll('.content-image-fader');
    if (faderList.length) {
        for (let fader of faderList) {
            const imgList = fader.querySelectorAll('.picture-target');

            // Delay should match the duration of the opacity transition
            let delay = 1000;

            // Timer can be adjusted as required on panel
            let timer = parseInt(fader.dataset.fadetimer);

            // If timer data attribute not defined or set default to 5000ms
            if (fader.dataset.fadetimer === null) {
                timer = 5000;
            }

            function fadeImg() {
                for (let img of imgList) {
                    if (img === fader.firstElementChild) {
                        img.classList.add('!opacity-0');

                        const shiftImageToBack = setTimeout(() => {
                            fader.appendChild(img);
                            clearTimeout(shiftImageToBack);
                        }, delay);

                        const resetImg = setTimeout(() => {
                            img.classList.remove('!opacity-0');
                            clearTimeout(resetImg);
                        }, timer);
                    }
                }
            }

            fadeImg();

            setInterval(() => {
                fadeImg();
            }, timer);
        }
    }
})